"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mitt_1 = __importDefault(require("mitt"));
class App {
    constructor(components) {
        this.add = this.add.bind(this);
        this.mount = this.mount.bind(this);
        this.components = new Map();
        this.createdComponents = new Map();
        this.emitter = (0, mitt_1.default)();
        this.eventListenerOptions = {
            once: true,
            passive: true,
        };
        this.add(components);
    }
    getComponentParams(element) {
        return [element, { app: this, emitter: this.emitter }];
    }
    getLoaderParams(element, callback) {
        return [{ node: element, emitter: this.emitter }, callback];
    }
    mountSyncComponent(element, component) {
        component(...this.getComponentParams(element));
    }
    mountAsyncComponent(element, component) {
        const disconnectors = [];
        let events = component[0];
        const callback = component[1];
        if (!Array.isArray(events)) {
            events = typeof events === 'string' ? events.split(' ') : [events];
        }
        const loadComponent = () => __awaiter(this, void 0, void 0, function* () {
            disconnectors.forEach((disconnect) => {
                disconnect();
            });
            (yield callback()).default(...this.getComponentParams(element));
        });
        events.forEach((event) => {
            if (typeof event === 'function') {
                disconnectors.push(event(...this.getLoaderParams(element, loadComponent)));
            }
            else {
                element.addEventListener(event, loadComponent, this.eventListenerOptions);
                disconnectors.push(() => {
                    element.removeEventListener(event, loadComponent, this.eventListenerOptions);
                });
            }
        });
    }
    add(components = {}) {
        Object.keys(components).forEach((key) => {
            this.components.set(key, components[key]);
        });
    }
    mount() {
        const elements = document.querySelectorAll('[data-component]');
        elements.forEach((element) => __awaiter(this, void 0, void 0, function* () {
            if (this.createdComponents.has(element)) {
                return;
            }
            const component = this.components.get(element.dataset.component);
            if (typeof component === 'undefined') {
                return;
            }
            this.createdComponents.set(element, true);
            if (Array.isArray(component)) {
                this.mountAsyncComponent(element, component);
            }
            else {
                this.mountSyncComponent(element, component);
            }
        }));
    }
}
exports.default = App;
